'use client'

import type React from 'react'
import { use } from 'react'
import { useModals } from '@/lib/hooks'
import { useAppSelector } from '@/lib/hooks/use-redux'

import { Dialog, DialogContent } from '@/components/ui'
import { EditCartItem } from '@/components/forms/edit-cart-item'
import { RefContext, type Refs } from '@/components/providers/ref-provider'

interface EditCartItemModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const EditCartItemModal = ({ open }: EditCartItemModalProps) => {
  const { closeModal } = useModals()
  const { product } = useAppSelector((state) => state.selectedProduct)
  const { barcodeInputRef } = use(RefContext) as Refs

  return (
    <Dialog open={open} onOpenChange={() => barcodeInputRef.current?.focus()}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('EDIT_CART_ITEM')}
        size="lg"
        className="min-h-[200px]"
      >
        {product && <EditCartItem product={product} />}
      </DialogContent>
    </Dialog>
  )
}
